import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4">
            <img 
              src="/site-assets/logo.jpg" 
              alt="Shriram Spectape" 
              className="h-10 w-auto brightness-0 invert"
            />
            <p className="text-gray-400 text-sm">
              Leading manufacturer of specialty adhesive tapes for industrial, automotive, and electronics applications.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/" className="hover:text-orange-500 transition-colors">Home</Link></li>
              <li><Link to="/features" className="hover:text-orange-500 transition-colors">Features</Link></li>
              <li><Link to="/industries" className="hover:text-orange-500 transition-colors">Industries</Link></li>
              <li><Link to="/products" className="hover:text-orange-500 transition-colors">Products</Link></li>
              <li><Link to="/blogs" className="hover:text-orange-500 transition-colors">Blogs</Link></li>
              <li><Link to="/contact" className="hover:text-orange-500 transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-lg mb-4">Products</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/products" className="hover:text-orange-500 transition-colors">Polyester Tapes</Link></li>
              <li><Link to="/products" className="hover:text-orange-500 transition-colors">Foam Tapes</Link></li>
              <li><Link to="/products" className="hover:text-orange-500 transition-colors">Insulation Tapes</Link></li>
              <li><Link to="/products" className="hover:text-orange-500 transition-colors">Specialty Tapes</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Phone: +91 7899862592</li>
              <li>Email: sales2@shriramspectape.com</li>
              <li>Shriram Spectape LLP<br />267 A, Bommasandra Jigani Link Rd,<br />Bommasandra Industrial Area,<br />Bengaluru, Karnataka 560105</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Shriram Spectape. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
